import PageHeader from "../Components/PageHeader";
import Section from "../Components/Section";
import Card from "../Components/Card";
import { service1Data } from "../Data/Data";
import useChangeTitle from "../Hooks/useChangeTitle.jsx";

export default function Service1() {
  useChangeTitle("HVAC Services");
  return (
    <>
      <PageHeader heading={service1Data.pageHeader} />
      
      {/* Hero Section with improved styling */}
      <Section title={service1Data.section1.title} className="py-12 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <p className="text-gray-600 leading-relaxed text-lg mb-8">
            {service1Data.section1.description}
          </p>
        </div>
      </Section>

      {/* Features Section */}
      <Section
        title={service1Data.section2.title}
        className="py-16 bg-white"
        desc="Our comprehensive HVAC solutions ensure optimal performance and energy efficiency"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
          {service1Data.section2.cards.map((card) => (
            <Card
              key={card.index}
              index={card.index}
              icon={card.icon}
              title={card.title}
              desc={card.desc}
            />
          ))}
        </div>
      </Section>

      {/* HVAC Image Gallery */}
      <Section title="Our HVAC Projects" className="py-16 bg-gray-50">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          <div className="relative overflow-hidden rounded-lg shadow-lg group">
            <img 
              src="/images/home/hvac home.JPG" 
              alt="HVAC Installation" 
              className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all duration-300"></div>
          </div>
          <div className="relative overflow-hidden rounded-lg shadow-lg group">
            <img 
              src="/images/home/hvac.jpg" 
              alt="HVAC Systems" 
              className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all duration-300"></div>
          </div>
          <div className="relative overflow-hidden rounded-lg shadow-lg group">
            <img 
              src="/images/services/hvac_231473096-1024x683.jpg" 
              alt="Professional HVAC" 
              className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all duration-300"></div>
          </div>
        </div>
      </Section>
    </>
  );
}
